<mat-sidenav-container class="layout" fxFlexFill>
  <mat-sidenav #sidenav class="sidenav-container">
      <mat-accordion>
        <a class="mat-expansion-panel-header" mat-flat-button [routerLink]="['/']" [routerLinkActive]="'active'"
           (click)="menuClick()" gaEvent="home" gaCategory="mobile_menu">Prima pagină</a>
        <a class="mat-expansion-panel-header" mat-flat-button [routerLink]="['/calcul', calculationRoutes.ONE_SLOPE, calculationStepRoutes.MODELS]"
           [routerLinkActive]="'active'"
           (click)="menuClick()" gaEvent="one_slope" gaCategory="mobile_menu">Calculator 1 Apa</a>
        <a class="mat-expansion-panel-header" mat-flat-button [routerLink]="['/calcul', calculationRoutes.TWO_SLOPES, calculationStepRoutes.MODELS]"
           [routerLinkActive]="'active'"
           (click)="menuClick()" gaEvent="two_slopes" gaCategory="mobile_menu">Calculator 2 Ape</a>
        <a class="mat-expansion-panel-header" mat-flat-button [routerLink]="['/calcul', calculationRoutes.FOUR_SLOPES, calculationStepRoutes.MODELS]"
           [routerLinkActive]="'active'"
           (click)="menuClick()" gaEvent="four_slopes" gaCategory="mobile_menu">Calculator 4 Ape</a>
        <a class="mat-expansion-panel-header" mat-flat-button [routerLink]="['/calcul', calculationRoutes.MANUAL, calculationStepRoutes.MODELS]"
           [routerLinkActive]="'active'"
           (click)="menuClick()" gaEvent="custom" gaCategory="mobile_menu">Calcul manual</a>
        <a class="mat-expansion-panel-header" mat-flat-button [routerLink]="['/calcul', calculationRoutes.FENCE_SLAT, calculationStepRoutes.MODELS]"
           [routerLinkActive]="'active'"
           (click)="menuClick()" gaEvent="fence_slat" gaCategory="mobile_menu">Sipca gard</a>
        <a class="mat-expansion-panel-header" mat-flat-button [routerLink]="['/sistem-pluvial']" [routerLinkActive]="'active'"
           (click)="menuClick()" gaEvent="rain_system" gaCategory="mobile_menu">Sistem pluvial</a>
        <a class="mat-expansion-panel-header" mat-flat-button [routerLink]="['/calcul-aproximativ']" [routerLinkActive]="'active'"
           (click)="menuClick()" gaEvent="approximative_price" gaCategory="mobile_menu">Preț aproximativ</a>
        <a class="mat-expansion-panel-header" mat-flat-button [routerLink]="['/produse']" [routerLinkActive]="'active'"
           (click)="menuClick()" gaEvent="product_prices" gaCategory="mobile_menu">Produse</a>
        <a class="mat-expansion-panel-header" mat-flat-button [routerLink]="['/custom-orders']" [routerLinkActive]="'active'"
           (click)="menuClick()" gaEvent="custom" gaCategory="mobile_menu">Comenzi personalizate</a>
          <mat-expansion-panel>
            <mat-expansion-panel-header>Specificatii produse</mat-expansion-panel-header>
            <a href="https://experttabla.ro/bilka/" mat-menu-item>Bilka</a>
            <a href="https://experttabla.ro/wetterbest/" mat-menu-item>Wetterbest</a>
          </mat-expansion-panel>
        <a class="mat-expansion-panel-header" mat-flat-button href="https://experttabla.ro/contact/" gaEvent="contact"
           gaCategory="mobile_menu">Contact</a>
      </mat-accordion>
  </mat-sidenav>
  <mat-sidenav-content fxFlexFill>
    <app-navigation (menuClick)="onMenuClick($event)"></app-navigation>
    <div id="wrapper">
      <xng-breadcrumb separator=">">
        <ng-container
          *xngBreadcrumbItem="
              let breadcrumb;
              let info = info;
              let last = last;
              let first = first
          ">
            <span *ngIf="last && !first || !last">{{ breadcrumb }}</span>
        </ng-container>
      </xng-breadcrumb>
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>

